<template>
  <v-form v-model="valid" ref="form">
      <div class="form-container px-10">
        <div class="form-group mb-12 text-center">
          <h1>{{title}}</h1>
          <h3 class="form-type">forgot password</h3>
        </div>
        <div class="form-group">
          <v-text-field
            outlined
            dense
            v-model="email"
            label="Email address"
            @keyup.enter="requestNewPassword"
            placeholder="Enter your email"
            :rules="[global.rules.email]"/>
        </div>
        <div class="form-group mb-2">
          <v-btn block color="primary" :loading="btnLoading" @click="requestNewPassword">Send recovery email</v-btn>
        </div>
        <div class="form-group text-center">
          <span>Back to<a style="margin-left: 5px" @click="AuthNavigateTo('gotoLogin')">Login </a> Page</span>
        </div>
        <div class="form-group text-center">
          <span>Or Create a<a style="margin-left: 5px" @click="AuthNavigateTo('gotoRegister')">New Account</a></span>
        </div>
      </div>
    </v-form>
</template>

<script>
import AuthPagesMixin from "../mixins/AuthPagesMixin"
import LoginStrings from "../views/Profile/LoginStrings"

export default {
  name: 'ForgetPasswordForm',
  mixins: [AuthPagesMixin],
  data() {
    return {
      email: '',
      valid: false,
      btnLoading: false,
    }
  },
  computed: {
    title() {
      return window.location.hostname.split(".").splice(1).join(".")
    }
  },
  methods: {
    requestNewPassword() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.btnLoading = true
      this.axios
        .post("/login/forgotpassword", {
          langkey: "en",
          login: this.email,
        })
        .then(() => {
          this.ShowInfo("info", LoginStrings(this, "email_sent"))
        })
        .catch(() => {
          this.ShowInfo("error", LoginStrings(this, "email_not_found"))
        }).finally(() => { 
          this.btnLoading = false
        })
    },
  }
}
</script>